import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  openEditDialog: false,
  editUserErrorMessage: null,
  editUserEmail: null,
  editUserFirstName: null,
  editUserSecondName: null,
  editUserId: null
}

export const editUserDlgSlice = createSlice({
  initialState,
  name: 'createUserDlg',
  reducers: {
    openEditDialog: (state) => {
      state.openEditDialog = true
    },
    closeEditDlg: (state) => {
      state.openEditDialog = false
    },
    setEditUserErrorMessage: (state, action) => {
      const message = action.payload
      state.editUserErrorMessage = message
    },
    setEditUserEmail: (state, action) => {
      const message = action.payload
      state.editUserEmail = message
    },
    setEditUserFirstName: (state, action) => {
      const message = action.payload
      state.editUserFirstName = message
    },
    setEditUserSecondName: (state, action) => {
      const message = action.payload
      state.editUserSecondName = message
    },
    setEditUserId: (state, action) => {
      const message = action.payload
      state.editUserId = message
    }
  }
})

export default editUserDlgSlice.reducer

export const {
  openEditDialog,
  closeEditDlg,
  setEditUserErrorMessage,
  setEditUserEmail,
  setEditUserFirstName,
  setEditUserSecondName,
  setEditUserId
} = editUserDlgSlice.actions
